document.addEventListener('favoriteToggle', (e) => {
  if (e.detail.linkElement && !e.detail.inFavorites) {
    const link = e.detail.linkElement;
    const card = link.closest('[data-favorite-card]');
    if (card) {
      card.remove();
    }
  }
});